<div fxLayout="column" fxLayoutAlign="center center" style="margin-top:120px;" fxFlex="100">

  <div fxLayout="row" fxLayoutAlign="start" fxFlex="100">
    <div class="pageTitle">Διαχείριση Ερωτήσεων Συναίνεσης</div>
  </div>


  <div fxLayout="column" style="margin-top:50px;" fxFlex="100">
    <div fxLayout="row" fxFlex="100" style="width:800px;">
      <mat-form-field fxFlex="95">
        <label>
          <input matInput [(ngModel)]="newQuestion" type="text" placeholder="Ερώτηση Συναίνεσης"/>
        </label>
      </mat-form-field>

      <button mat-icon-button fxFlex="5" matTooltip="Προσθήκη" (click)="insertQuestion()"><mat-icon>add</mat-icon></button>

    </div>
  </div>

  <div fxLayout="row" style="margin-top:20px; width:800px;">

    <div class="questionsContainer" fxLayout="column">
      <ng-container *ngIf="loadingQuestions; else ShowQuestions">
        <app-loading></app-loading>
      </ng-container>

      <ng-template #ShowQuestions>
      <div *ngFor="let question of consentQuestions" fxFlex="100" fxLayout="row">

        <div fxFlex="5" fxLayoutAlign="center center">
          {{question.id}}
        </div>

        <div fxFlex="85" fxLayoutAlign="start center">
          {{question.title}}
        </div>

        <div fxFlex="10" fxLayoutAlign="center center" fxLayout="column">
          <div fxLayout="row">
<!--            <button mat-icon-button matTooltip="Ενημέρωση">-->
<!--              <mat-icon>edit</mat-icon>-->
<!--            </button>-->
            <button [disabled]="+question.assigned === 1" mat-icon-button matTooltip="Διαγραφή" (click)="confirmDeletion(question)">
              <mat-icon>delete</mat-icon>
            </button>
          </div>

        </div>

      </div>
      </ng-template>
    </div>

  </div>

</div>
